import React from "react";
import { styled } from "@mui/styles";
import { CircularProgress } from "@mui/material";

const Root = styled('div')({
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    minHeight: '100%',
});

function Loader() {
  return (
    <Root>
      <CircularProgress m={2} color="secondary" />
    </Root>
  );
}

export default Loader;
